import { addMonths, format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import eachMonthOfInterval from 'date-fns/eachMonthOfInterval'

export const ensureLastYearMonths = () => {
  const end = new Date()
  const start = addMonths(end, -11)

  const monthsDates = eachMonthOfInterval({
    start,
    end
  })

  const months = monthsDates.map(month => ({
    name: format(month, 'MMMM',{ locale: ptBR }),
    value: format(month, 'MM',{ locale: ptBR })
  })).reverse()

  return months
}
